var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "id",
      label: "ID"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "姓名"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "status",
      label: "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status === 0 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "info"
          }
        }, [_vm._v("未开始")]) : _vm._e(), scope.row.status === 1 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "warning"
          }
        }, [_vm._v("进行中")]) : _vm._e(), scope.row.status === 2 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "success"
          }
        }, [_vm._v("已结束")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "start_time",
      label: "开始时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.start_time ? _vm.dayjs(scope.row.start_time * 1000).format("HH:mm:ss") : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "end_time",
      label: "结束时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.end_time ? _vm.dayjs(scope.row.end_time * 1000).format("HH:mm:ss") : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "end_time",
      label: "用时"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.end_time && scope.row.start_time ? [_vm._v(" " + _vm._s(_vm.formatDuration(scope.row.end_time - scope.row.start_time)) + " ")] : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "work_report_score",
      label: "工作汇报"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "inspire_score",
      label: "启发&灵感"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "interesting_score",
      label: "生动&有趣"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "time_control_score",
      label: "时间管理"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "total_avg_score",
      label: "总平均分"
    }
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status === 0 ? _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleStart(scope.row);
            }
          }
        }, [_vm._v("开始")]) : scope.row.status === 1 ? [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleEnd(scope.row, scope.row.end_time ? 2 : 1);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.end_time ? "结束" : "讨论") + " ")])] : _vm._e()];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };